import { Component } from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../../services/auth.service";
import {addDoc, collection, Firestore} from "@angular/fire/firestore";
import {HelperService} from "../../../services/helpers/helper.service";
import {ModalHeaderComponent} from "../../../layout/modal-header/modal-header.component";
import {NgIf} from "@angular/common";
import {AutofocusDirective} from "../../../directives/autofocus/autofocus.directive";

@Component({
    selector: 'app-get-in-touch',
    imports: [
        FormsModule,
        MatDialogContent,
        ModalHeaderComponent,
        NgIf,
        ReactiveFormsModule,
        AutofocusDirective,
    ],
    templateUrl: './get-in-touch.component.html',
    styleUrl: './get-in-touch.component.scss'
})
export class GetInTouchComponent {
  form: FormGroup
  submitting = false
  error = false
  success = false

  constructor(
    public dialogRef: MatDialogRef<GetInTouchComponent>,
    private authSvc: AuthService,
    private firestore: Firestore,
    public helperSvc: HelperService
  ) {
    this.form = new FormGroup<any>({
      subject: new FormControl('In-app contact form', Validators.required),
      message: new FormControl('', [Validators.required, Validators.maxLength(2000)]),
      path: new FormControl(location.pathname),
      email: new FormControl(this.authSvc.email),
      uid: new FormControl(this.authSvc.uid),
      date: new FormControl(new Date().getTime()),
      type: new FormControl('help')
    })
  }

  get type() { return this.form.get('type') as FormControl }
  get subject() { return this.form.get('subject') as FormControl }
  get message() { return this.form.get('message') as FormControl }

  async send() {
    this.form.markAllAsTouched()
    if (this.form.valid) {
      this.submitting = true
      try {
        await addDoc(collection(this.firestore, 'feedback'), this.form.value)
        this.success = true
      } catch (e) {
        this.error = true
      }
      this.submitting = false
    }
  }

}
